// @flow
import * as React from "react"
import withQuery from "hoc/withQuery"
import type { HOC } from "recompose"
import { reservationListQuery } from "data/reservations/graphql/queries"
import ReservationsList from "components/ReservationList"
import { PageTitle } from "componentsStyled/Typography/Titles"
import { Offset } from "componentsStyled/Layout/Offset"
import { Space } from "componentsStyled/Layout/Spacers"
import { reverse } from "ramda"

const UpcomingReservations = ({ data }) => {
  if (!data || !data.confirmed) return null

  const upcoming = reverse(data.confirmed)

  return (
    <Offset>
      <Space />
      <PageTitle>Upcoming</PageTitle>
      <ReservationsList reservations={upcoming} />
    </Offset>
  )
}

const enhancer: HOC<*, {||}> = withQuery(reservationListQuery, {
  noEmpty: true,
})

export default enhancer(UpcomingReservations)



// WEBPACK FOOTER //
// ./src/pages/Products/UpcomingReservations.js